export default __webpack_public_path__ + "static/media/ba15.a0af8c05.jpg";